<template>
  <v-container class="pa-0 ma-0" fluid>
    <!-- header-mobile -->
<!--    <v-slide-x-transition leave-absolute>-->
      <v-img
        class="d-flex d-md-none img-loc white--text"
        :src="$route.name === 'Inicio' ? require('@/assets/fondos/inicio.svg') : require('@/assets/fondos/frame.svg')"
        :min-height="$route.name === 'Inicio' ? '95vw': '72vw'"
        max-height="795px"
        cover
      >
        <v-row class="pa-2" v-if="$route.name === 'Inicio'">
          <v-col cols="6" style="height:70px">
            <v-app-bar-nav-icon
              class="ml-5"
              color="white"
              @click.stop="SET_DRAWER(!drawer)"
            />
          </v-col>
          <v-col :class="'mr-2'" align="end" cols="5" style="height:70px;">
            <img src="@/assets/logos/logo-inicio.svg" alt="">
          </v-col>
        </v-row>
        <div>
          <v-btn v-if="$route.name !== 'Inicio'" @click="goBack()" style="margin-top: 12%;" class="btn-atras-inicio" exact>
            <v-icon class="ml-5" color="white" dark>mdi-arrow-left</v-icon>
          </v-btn>
          <v-container class="ml-0 d-flex justify-center" style="margin-top: 3%">
            <p class="font-size-1-5" v-if="$route.name !== 'Inicio'">{{ capitalize($route.meta.appBarTitle) }}</p>
          </v-container>
          <!-- use double and not conditional becasue transition loose -->
          <v-slide-x-transition>
            <v-img
              v-if="$route.name === 'SeleccionarCategoria' || $route.name === 'SeleccionarCategoriaRepaso' || $route.name === 'SeleccionarTipoSimulacro' || $route.name === 'SeleccionarSimulacro'"
              src="@/assets/img/enfermero-categorias.svg"
              height="232"
              max-width="90"
              style="position: absolute; top: 40px; right: 15px;"
            />
          </v-slide-x-transition>
          <v-slide-x-transition>
            <v-img
              v-if="$route.name !== 'SeleccionarCategoria' && $route.name !== 'SeleccionarCategoriaRepaso' && $route.name !== 'SeleccionarTipoSimulacro' && $route.name !== 'SeleccionarSimulacro' && $route.name !== 'Inicio'"
              src="@/assets/img/enfermero-temas.svg"
              height="232"
              max-width="90"
              style="position: absolute; top: 50px; right: 20px;"
            />
          </v-slide-x-transition>
        </div>
      </v-img>
    <v-row class="mx-auto mb-10 ma-0" style="width: 100%;">
      <!-- PRIMERA COLUMNA -->
      <v-col cols="12" xs="12" sm="12" md="4" class="mt-15 sidebar">
        <card-avatar
          :width="$vuetify.breakpoint.mdAndUp ? '80%': '100%'"
          :fotoPerfil="fotoPerfil"
          :nombreUsuario="nombreUsuario"
          class="mx-auto"
        />
      </v-col>
      <!-- PRIMERA COLUMNA -->
      <!-- SEGUNDA COLUMNA -->
      <v-col v-if="$route.name !== 'SeleccionarSimulacro'" class="mt-10 pa-0 d-flex justify-center align-center" cols="12" xs="12" sm="12" md="4">
        <v-slide-y-transition hide-on-leave>
          <router-view></router-view>
        </v-slide-y-transition>
      </v-col>
      <!-- SEGUNDA COLUMNA -->
      <!-- TERCERA COLUMNA -->
      <v-col v-if="$route.name !== 'SeleccionarSimulacro'" cols="12" xs="12" sm="12" md="4" class="d-none d-md-flex align-center mt-15" align-self="start">
        <ranking-general
          :periodo="periodo"
          titulo="Ranking General"
          porPeriodo="true"
          tamanioFoto="30px"
        />
      </v-col>
      <!-- TERCERA COLUMNA -->
      <!-- CUARTA COLUMNA SIMMULACRO -->
      <v-col v-if="$route.name === 'SeleccionarSimulacro'" cols="12" xs="12" sm="12" md="8" align-self="center">
        <v-slide-y-transition hide-on-leave>
          <router-view></router-view>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardAvatar from '@/components/inicio/CardAvatar'
import RankingGeneral from '@/components/ranking/RankingGeneral'
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { canjearCupon } from '@/utils/mixins'

export default {
  components: {
    CardAvatar,
    RankingGeneral
  },
  mixins: [canjearCupon],
  data () {
    return {
      periodo: 'Semanal'
    }
  },
  computed: {
    ...mapState('perfil', ['user']),
    ...mapState(['drawer']),
    ...mapGetters('perfil', ['fotoPerfil', 'nombreUsuario']),
    headerImg () {
      if (this.$route.name === 'SeleccionarCategoria' || this.$route.name === 'SeleccionarTipoPregunta') {
        return '@/assets/img/enfermero-temas.svg'
      } else {
        return '@/assets/img/enfermero-categorias.svg'
      }
    }
  },
  watch: {
    group () {
      this.drawer = false
    }
  },
  methods: {
    ...mapActions('perfil', ['fetchUser']),
    ...mapMutations(['SET_DRAWER']),
    capitalize (word) {
      const lower = word.toLowerCase()
      return word.charAt(0).toUpperCase() + lower.slice(1)
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  async created () {
    // await this.fetchUser()
    await this.verificarCupon()
  }

}
</script>

<style lang="scss" scoped>
.sidebar {
}
@media (max-width: 960px) {
  .sidebar {
    margin-top: -75% !important;
  }
}
</style>
